<app-generic-modal #genericModal
  (primaryActionEvent)="submit()"
  [primaryActionEnabled]="isValid()"
  [title]="'Add several Full LOT No.'"
  [primaryActionTitle]="'Add Full LOT No.'"
  [secondaryActionTitle]="'Discard'">
  <div class="modal-body">
    <p class="modal-body-title" data-cy="modal-body-info-description">Please paste Full LOT numbers</p>
    @if (limitOfChipsInTextAreaExceeded) {
      <div class="modal-body-limit-exceeded-error-message">
        <span class="iwp-icon-pc_info_warning"></span>
        <span>{{limitExceededErrorMessage}}</span>
      </div>
    }
    <div class="modal-body-paste-area" tabindex="-1"
      [ngStyle]="{'height': pastAreaHeight}"
      [ngClass]="{'limit-exceeded': limitOfChipsInTextAreaExceeded}">
      <textarea class="modal-body-paste-area-text"
        data-cy="modal-body-paste-area-text"
        maxlength="0"
        [ngStyle]="{'height': scrollablePastAreaTextHeight}"
        [placeholder]="pastAreaTextHeightPlaceholder"
      (paste)="pasteHandler($event)"></textarea>
      <div #pasteAreaChips class="modal-body-paste-area-chips">
        @for (chip of state.fullLotNumbersChips; track chip; let index = $index) {
          <app-pnc-full-lot-number-chip [data]="chip"
            [position]="index"
            [isWithinLimit]="isChipWithinLimit(index)"
          (deleteChip)="onChipDelete($event)"></app-pnc-full-lot-number-chip>
        }
      </div>
    </div>
  </div>
</app-generic-modal>
